<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">
        {{ 'channel.edit.modalTitle' | translate }}
      </h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup" class="w-100 col-lg-8">
        <div class="row">

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'channel.edit.nameLabel' | translate }}</label>
            <input formControlName="name" class="form-control" [placeholder]="'channel.edit.namePlaceholder' | translate"
              maxlength="100" />
            <field-error-component [field]="'name'" [label]="'channel.edit.nameErrorLabel' | translate" [formGroup]="formGroup" />
          </div>

          @if (formGroup.get('type')?.value === 'CLOUD_API' ) {
          @if (formGroup.get('integration')?.value === false) {
          <div class="d-flex flex-column" formGroupName="credentials">
            <div class="col-12 mb-3">
              <label class="form-label">Token *</label>
              <input type="password" formControlName="token" class="form-control" [placeholder]="'channel.edit.tokenPlaceholder' | translate">
              <field-error-component [field]="'credentials.token'" [label]="'Token'"
                [formGroup]="formGroup"></field-error-component>
            </div>

            <div class="col-12">
              <div class="row">
                <div class="col-md-6">
                  <label class="form-label">Phone Number ID *</label>
                  <input maxlength="100" formControlName="phoneNumberID" class="form-control"
                    [placeholder]="'channel.edit.phoneNumberIdPlaceholder' | translate">
                  <field-error-component [field]="'credentials.phoneNumberID'" [label]="'Phone Number ID'"
                    [formGroup]="formGroup" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">WhatsApp Business Account ID *</label>
                  <input maxlength="100" formControlName="whatsAppBusinessAccountID" class="form-control"
                    [placeholder]="'channel.edit.whatsAppBusinessIdPlaceholder' | translate">
                  <field-error-component [field]="'credentials.whatsAppBusinessAccountID'" [label]="'WhatsApp Business Account ID'"
                    [formGroup]="formGroup" />
                </div>
              </div>
            </div>
          </div>
          } @else {
          <br />
          <!-- The dialog always edits an existing channel, so the signup carries its id. -->
          <app-whatsapp-signup [disabledButton]="!getName()" [nameChannel]="getName()" [idChannel]="$safeNavigationMigration(data?._id)"
            [creditLine]="!!data?.creditLine"
            (onSave)="goBack()" />
          }
          }

          @if (formGroup.get('type')?.value === 'WEBCHAT_API') {
          <div class="d-flex flex-column" formGroupName="webchat">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">{{ 'channel.channelForm.webchatPrimaryColorLabel' | translate }}</label>
                <input formControlName="primaryColor" type="color" class="form-control form-control-color w-100" />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">{{ 'channel.channelForm.webchatButtonPositionLabel' | translate }}</label>
                <mat-select class="form-control" formControlName="buttonPosition">
                  <mat-option value="right">{{ 'channel.channelForm.webchatButtonPositionRight' | translate }}</mat-option>
                  <mat-option value="left">{{ 'channel.channelForm.webchatButtonPositionLeft' | translate }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div class="col-12 mb-3">
              <label class="form-label">{{ 'channel.channelForm.webchatLogoLabel' | translate }}</label>
              <webchat-logo-upload-component formControlName="logoUrl" />
            </div>
            <div class="col-12 mb-3">
              <label class="form-label">{{ 'channel.channelForm.webchatPrivacyPolicyUrlLabel' | translate }}</label>
              <input formControlName="privacyPolicyUrl" class="form-control" placeholder="https://" />
            </div>
          </div>
          }

          @if (formGroup.get('type')?.value === 'RCS_API' ) {
          <!-- RCS has no Embedded Signup (unlike Cloud API): the provider account is always typed in. -->
          <div class="d-flex flex-column" formGroupName="credentials">
            <div class="d-flex flex-column mb-3">
              <label class="form-label">{{ 'channel.edit.accountLabel' | translate }}</label>
              <input formControlName="account" class="form-control" [placeholder]="'channel.edit.accountPlaceholder' | translate">
              <field-error-component [field]="'credentials.account'" [label]="'channel.edit.accountErrorLabel' | translate" [formGroup]="formGroup">
              </field-error-component>
            </div>
          </div>

          <!--
            RCS is conversational-only: there is no campaign-only ("single") account any more,
            so the capability is no longer an operator choice. The switch is kept commented out
            (with its i18n keys) in case the distinction ever comes back. The `rcs` FormGroup
            still exists in the component and always saves `conversational: true`.

          <div class="d-flex justify-content-between align-items-center mt-3" formGroupName="rcs">
            <div class="me-3">
              <h5 class="mb-0 fw-bold">{{ 'channel.channelForm.rcsConversationalLabel' | translate }}</h5>
              <p class="text-muted mb-0">{{ 'channel.channelForm.rcsConversationalHelp' | translate }}</p>
            </div>
            <div class="custom-switch">
              <input type="checkbox" id="rcsConversationalEdit" data-switch="success" formControlName="conversational">
              <label for="rcsConversationalEdit"></label>
            </div>
          </div>
          -->
          }

        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'channel.edit.cancel' | translate }}
      </button>
      @if (showSaveButton()) {
      <button type="submit" class="btn btn-primary" [mat-dialog-close]="true" [disabled]="!formGroup.valid"
        (click)="save()">
        {{ 'channel.edit.save' | translate }}
      </button>
      }
    </div>

  </div>
</div>